var tl = new TimelineMax({paused:true, onComplete: function(){
	$('.sticla').removeAttr('style');
}})
	.fromTo('.vultur', 0.4, {opacity:0, x: '-200%', y: '30%', scale: 0.7}, {opacity:1, x: '0%', y: '0%', scale:1, ease: Power2.easeOut})
	.fromTo('.sticla', 0.8, {opacity:0, y: '50%'}, {opacity:1, y: '0%', ease: Power2.easeOut}, '-=0.2')
	.staggerFromTo('.section1 .videocontainer, .section1 p, .ziua-reintalnirii-stripe', 0.5, {opacity:0,y: 20}, {opacity:1, y:0, ease: Power2.easeOut}, 0.25, '-=0.5'), player, mobileplayer;

function onYouTubeIframeAPIReady() {
	player = new YT.Player('player', {
		height: '315',
		width: '560',
		videoId: 'xoZssOWw3v0',
		//host: 'http://bergenbier.lara',
		playerVars: {
			modestbranding: 1,
			rel: 0
		}
	});
	mobileplayer = new YT.Player('mobileplayer', {
		height: '315',
		width: '560',
		videoId: 'xoZssOWw3v0',
		//host: 'http://bergenbier.lara',
		playerVars: {
			modestbranding: 1,
			rel: 0
		}
	});
}

$(window).load(function() {
	TweenMax.to($('.preloader'), .5, {
		delay: 0.5,
		opacity: 0,
		display: 'none',
        onComplete: function(){
			tl.play();
        }
	});

	$('.sticla, .line1').on('click', function(){
		if ( window.matchMedia("(max-width: 767px)").matches ) {
			mobileplayer.playVideo();
			$('#customVideoModal').modal('show');
		} else {
			player.playVideo();
		}
	});

	$('#scrollShops').on('click', function(e){
		e.preventDefault();
		scrollToSection('.section4');
	});

	var video1 = document.querySelector("#video1"),
		video2 = document.querySelector("#video2");

	if ( window.matchMedia("(max-width: 767px)").matches ) {
		video1.autoplay = true;
		video2.autoplay = true;
		video1.load();
		video2.load();
	} else {
		$('#video1').on('mouseenter', function(){
			video1.play();
		}).on('mouseleave', function(){
			video1.pause();
		});
		$('#video2').on('mouseenter', function(){
			video2.play();
		}).on('mouseleave', function(){
			video2.pause();
		});
	}

});

$('.modal-backdrop, #customVideoModal .close, #customVideoModal .btn, #customVideoModal:not(.modal-content), #customVideoModal:not(.modal-body), #customVideoModal:not(.modal-header)').on('click', function() {
	mobileplayer.pauseVideo();
});
